import cx from 'classnames';

import Button from 'lib/common/components/Button/Button';
import Text from 'lib/common/components/Text';

import styles from './confirm-modal.module.scss';

export default function ConfirmModal({
  message,
  onCancel,
  onConfirm,
  confirmLabel,
  cancelLabel,
  danger,
}: {
  message: React.ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
  confirmLabel: string;
  cancelLabel: string;
  danger?: boolean;
}) {
  return (
    <div className={styles['confirm-modal-step__container']}>
      <Text>{message}</Text>
      <div className="next-to-10 justify-end">
        <Button onClick={onCancel} styleType="SECONDARY">
          {cancelLabel}
        </Button>
        <Button styleType={danger ? 'DANGER' : 'PRIMARY'} asyncAction onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </div>
    </div>
  );
}
